module.exports = __webpack_public_path__ + "20250721160708/img/collect.9f153a8e.png";